import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useWineListData, getWineListBackPath } from '../hooks/useWineListData';
import ArrowLeftIcon from './icons/ArrowLeftIcon';
import LoadingSpinner from './LoadingSpinner';
import WineFilters from './wine/WineFilters';
import WineCard from './wine/WineCard';
import WineListHeader from './wine/WineListHeader';

const priceRanges = [
  { id: 'todos', label: 'Todos os Preços', min: 0, max: Infinity },
  { id: 'ate-100', label: 'Até R$ 100', min: 0, max: 100, icon: '💸' },
  { id: '100-150', label: 'R$ 100 - R$ 150', min: 100, max: 150, icon: '💰' },
  { id: '150-200', label: 'R$ 150 - R$ 200', min: 150, max: 200, icon: '💵' },
  { id: '200-300', label: 'R$ 200 - R$ 300', min: 200, max: 300, icon: '💎' },
  { id: 'acima-300', label: 'Acima de R$ 300', min: 300, max: Infinity, icon: '👑' },
];

const WineList = () => {
  const navigate = useNavigate();
  const { category, foodId, regionId } = useParams();
  const [loading, setLoading] = useState(true);
  const [classificationFilter, setClassificationFilter] = useState('todos');
  const [grapeFilter, setGrapeFilter] = useState('todas');
  const [priceRange, setPriceRange] = useState('todos');
  const [sortOrder, setSortOrder] = useState('nome');

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(timer);
  }, [category, foodId, regionId]);

  const listData = useWineListData({
    category,
    foodId,
    regionId,
    classificationFilter,
    grapeFilter,
    priceRange,
    sortOrder,
    priceRanges,
  });

  if (loading) {
    return <LoadingSpinner message="Carregando vinhos..." />;
  }

  const handleBack = () => navigate(getWineListBackPath(listData.selectedFood, listData.selectedRegion));

  return (
    <div className="min-h-screen bg-gradient-to-br from-wine-dark via-[#1e1a2e] to-wine-dark py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center mb-8">
          <button
            type="button"
            onClick={handleBack}
            className="flex items-center gap-2 text-white hover:text-wine-gold transition-colors"
          >
            <ArrowLeftIcon />
            <span className="text-lg">Voltar</span>
          </button>
        </div>

        <WineListHeader
          selectedFood={listData.selectedFood}
          selectedRegion={listData.selectedRegion}
          isGrapeCategory={listData.isGrapeCategory}
          isPriceCategory={listData.isPriceCategory}
          pageTitle={listData.pageTitle}
          resultCount={listData.resultCount}
        />

        <WineFilters
          classificationFilter={classificationFilter}
          setClassificationFilter={setClassificationFilter}
          grapeFilter={grapeFilter}
          setGrapeFilter={setGrapeFilter}
          priceRange={priceRange}
          setPriceRange={setPriceRange}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          availableGrapes={listData.availableGrapes}
          priceRanges={priceRanges}
          isGrapeCategory={listData.isGrapeCategory}
          isPriceCategory={listData.isPriceCategory}
        />

        {listData.filteredWines.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-400 text-xl mb-4">Nenhum vinho encontrado para essa harmonização</p>
            <button type="button" onClick={handleBack} className="text-wine-gold hover:text-white transition-colors">
              Voltar e escolher outro prato
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 tablet-landscape:grid-cols-4 gap-4 md:gap-6 tablet-landscape:gap-4">
            {listData.filteredWines.map((wine) => (
              <WineCard key={wine.id} wine={wine} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WineList;
